<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-data-table
        :headers="headers"
        :items="userActions"
        :search="search"
        class="elevation-0"
        item-key="eventid"
        :footer-props="footerProps" no-data-text="пусто" no-results-text="ничего не найдено"
        :items-per-page.sync="itemsPerPage"
        dense flat
      >
        <template v-slot:item.action="{ item }">
          <v-btn
            v-if="item.action"
            text small color="primary" class="caption"
            @click="$emit('search', item.action)"
          >{{ item.action }}</v-btn>
        </template>
        <template v-slot:item.interface="{ item }">
          <v-btn
            v-if="item.interface"
            text small color="primary" class="caption"
            @click="$emit('search', item.interface)"
          >{{ item.interface }}</v-btn>
        </template>
        <template v-slot:item.more="{ item }">
          <v-btn
            text small color="green" class="caption"
            @click="open(item)"
          >Подробнее</v-btn>
        </template>
      </v-data-table>
    </v-flex>
    <v-dialog
      v-model="dialog"
      scrollable 
      persistent :overlay="false"
      max-width="80%"
      transition="dialog-transition"
    >
      <v-card>
        <v-toolbar flat>
          <v-card-title primary-title>
            Пользовательское действие "{{ userAction.action }}" в интерфейсе "{{ userAction.interface }}"
          </v-card-title>
          <v-spacer></v-spacer>
          <v-btn text icon @click="close()">
            <v-icon small>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <div>
            <table width="100%">
              <tr>
                <th width="50%" class="px-2 py-2">Было</th>
                <th width="50%" class="px-2 py-2">Стало</th>
              </tr>
              <tr>
                <td width="50%" class="px-2 py-2"><pre><span v-html="values[0]"></span></pre></td>
                <td width="50%" class="px-2 py-2"><pre><span v-html="values[1]"></span></pre></td>
              </tr>
            </table>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="close()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
const jb = require('json-beautify')
const diff = require('recursive-diff')
export default {
  name: 'ListUserActions',
  props: [ 'userActions', 'sort-by', 'search'],
  data: () => ({
    headers: [
      { text: 'id', value: 'id' },
      { text: 'Действие', value: 'action', },
      { text: 'Интерфейс', value: 'interface', },
      { text: 'Подробнее', value: 'more', },
      { text: 'Дата', value: 'cts', },
    ],
    footerProps: {
      itemsPerPageText: 'показывать записей',
      itemsPerPageOptions: [ 25, 50, 100, { text: 'Все', value: -1 } ]
    },
    itemsPerPage: 25,
    dialog: false,
    userAction: {},
    objDiff: null,
    values: [],
    newOne: ''
  }),
  computed: {
  },
  methods: {
    open (item) {
      this.dialog = true
      this.userAction = item
      this.objDiff = diff.getDiff(item.oldvalue, item.newvalue)
      this.values = this.beautify(this.userAction)
    },
    close () {
      this.dialog = false
      this.userAction = {}
    },
    beautify (obj) {
      let oldValue = obj.oldvalue ? jb(obj.oldvalue, null, 2, 80) : null
      let newValue = obj.newvalue ? jb(obj.newvalue, null, 2, 80) : null
      if (this.objDiff) {
        if (this.objDiff[0].path === undefined && this.objDiff[0].val) {
          newValue = newValue.split('\n').map(x => {
            x = `<b><span style="${this.opColor(this.objDiff[0].op)}">${x}</span></b>`
            return x
          }).join('\n')
        }
        if (this.objDiff.length !== 0) {
          this.objDiff.forEach(p => {
            if (p.path && p.path[0] !== undefined) {
              if (oldValue) {
                oldValue = oldValue.split('\n').map(x => {
                  if (x.includes(p.path[0])) {
                    x = `<b><span style="${this.opColor(p.op)}">${x}</span></b>`
                  }
                  return x
                }).join('\n')
              }
              if (newValue) {
                newValue = newValue.split('\n').map(x => {
                  if (x.includes(p.path[0])) {
                    x = `<b><span style="${this.opColor(p.op)}">${x}</span></b>`
                  }
                  return x
                }).join('\n')
              }
            }
          })
        }
      }
      return [oldValue, newValue]
    },
    opColor (operation) {
      if (operation === 'update') return 'color:#f5811b'
      if (operation === 'delete') return 'color:#de0b0b'
      if (operation === 'add') return 'color:#02a12f'
      return 'color:black'
    }
  },
  watch: {
  },
  mounted () {}
}
</script>

<style lang="css">
</style>
